export default function BlogCTA() {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-sky-600 to-sky-700">
      <div className="max-w-4xl mx-auto text-center text-white">
        <div className="w-20 h-20 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full mx-auto mb-6">
          <i className="ri-mail-line text-4xl"></i>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Stay Updated with Painting Tips
        </h2>
        <p className="text-xl mb-8 text-white/95">
          Get expert advice, exclusive tips, and special offers delivered to your inbox. Join Watford homeowners who trust Brushour for painting insights.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-2xl mx-auto">
          <a
            href="/contact"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-sky-600 font-bold rounded-lg hover:bg-slate-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-message-3-line text-xl"></i>
            Contact Us
          </a>
          <a
            href="/booking"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-sky-800 text-white font-bold rounded-lg hover:bg-sky-900 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line text-xl"></i>
            Book Free Consultation
          </a>
        </div>
        <div className="mt-8 flex flex-wrap justify-center gap-6 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-xl"></i>
            <span>Free Expert Advice</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-xl"></i>
            <span>No Obligation Quotes</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-xl"></i>
            <span>Serving All Hertfordshire</span>
          </div>
        </div>
      </div>
    </section>
  );
}